module.exports = __webpack_public_path__ + "img/logo.3d6bd3f0.png";